// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3hr0Z","notes":"Notes_notes__FBdOm","note":"Notes_note__UMVC2","markdown":"Notes_markdown__2iHNZ"};